function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import json5 from "json5";
import Resource from "terriajs-cesium/Source/Core/Resource";
const defaultHeaders = {
  Accept: "application/json5,application/json;q=0.8,*/*;q=0.01"
};

/*
 * A modified version of Cesium's loadJson function, supporting the more flexible JSON5 specification.
 */
export default function loadJson5(urlOrResource, headers) {
  let resource;
  if (urlOrResource instanceof Resource) {
    resource = urlOrResource;
  } else {
    resource = new Resource({
      url: urlOrResource,
      headers: _objectSpread(_objectSpread({}, defaultHeaders), headers)
    });
  }
  const promise = resource.fetchText();
  return promise.then(function (value) {
    return json5.parse(value);
  });
}

// Use these headers if passing a Cesium Resource to loadJson5
loadJson5.defaultHeaders = defaultHeaders;